import { MutationType } from '@tencent/slide-sdk-pb-model';
import { BaseMutation } from '../base/base-mutation';
import type { PresentationDataModel } from '../../model/presentation-data-model';
import type { MaybeError } from '../base/base-mutation';
import type { IValidEmptyMutationData } from '../base/valid-mutation-data';

export class EmptyMutation extends BaseMutation<PresentationDataModel, IValidEmptyMutationData> {
    public readonly type: MutationType = MutationType.Empty;

    public apply() {
        // Do nothing
    }

    public invert(): [] {
        // Do nothing
        return [];
    }

    public check(): MaybeError {
        // Do nothing
        return;
    }
}
